import React from 'react'
const AddIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16.6663 9.51148C17.1265 9.51145 17.4998 9.88472 17.4998 10.345C17.4996 10.805 17.1269 11.1774 16.667 11.1777L10.832 11.1777V17.0114C10.8318 17.4714 10.4592 17.8453 9.99917 17.8455C9.53898 17.8456 9.16642 17.4716 9.16639 17.0114V11.1777L3.33345 11.1784C2.87322 11.1785 2.49925 10.8059 2.49928 10.3456C2.49942 9.88554 2.87334 9.51296 3.33345 9.51286L9.16708 9.51148V3.67785C9.16732 3.21781 9.53978 2.84513 9.99986 2.84507C10.46 2.84503 10.8325 3.21774 10.8326 3.67785L10.8326 9.51148L16.6663 9.51148Z"
        fill="#B6B6BA"
      />
    </svg>
  )
}

export default AddIcon
